//
import { RouteNames } from '@/router/routeNames';
import Dashboard from './Dashboard.vue';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw = {
  name: RouteNames.DASHBOARD,
  path: 'dashboard',
  props: true,
  component: Dashboard,
  meta: {
    pageTitle: 'Landing.Dashboard',
  },
};

export default routes;
